import { useQuery } from '@tanstack/react-query';
import { fetchAdminMe } from '@/lib/auth/admin-auth';
import { queryKeys } from '@/lib/query/query-keys';
import { queryPolicies } from '@/lib/query/query-client';

export function useAdminMe() {
  return useQuery({
    queryKey: queryKeys.admin.me,
    queryFn: fetchAdminMe,
    ...queryPolicies.tenantConfig,
    staleTime: 5 * 60_000,
  });
}
